/* eslint-disable react-hooks/exhaustive-deps */

import Grid from "@material-ui/core/Grid";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {useQuery} from "@apollo/react-hooks";
import {GET_ACCOUNT} from "../../database/queries/accountQueries";
import {GET_CONTACT} from "../../database/queries/contactQueries";
import {GET_PROJECT} from "../../database/queries/projectQueries";
import {notify} from "../../utils/notify";
import {GET_MY_RESOURCES} from "../../database/queries/userQueries";
import ChooseTargetDialog from "../../dialogs/chooseTarget";
import IconButton from "@material-ui/core/IconButton";
import BuildIcon from '@material-ui/icons/Build';
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import {TARGET_TYPES} from "../../constants/types";

const useStyles = makeStyles(theme => ({
    formControl: {
        marginTop: 0,
        marginBottom: 0,
        'input': {
            '&::placeholder': {
                color: 'blue'
            }
        },
        '& .MuiFormLabel-root': {
            color: '#a0aec0'
        },
        '& .MuiAutocomplete-inputRoot': {
            paddingBottom: 0,
        }
    },
    leftField: {
        paddingRight: 10
    },
    middleField: {
        backgroundColor: '#e0e0e0',
        paddingLeft: 10,
        paddingRight: 10
    },
    rightField: {
        paddingLeft: 10,
    },
    gridContainer: {
        // backgroundColor: '#e0e0e0',
    }
}));

const ShareTarget = (props) => {
    const classes = useStyles();
    const [target, setTarget] = useState({type: 'general', id: 'general', name: ''});
    const [resources, setResources] = useState();
    const [chooseTargetDialogOpen, setChooseTargetDialogOpen] = useState(false);

    const {error: getUserResourcesError, data: getUserResourcesData} = useQuery(GET_MY_RESOURCES, {
        skip: resources
    });

    const {error: getAccountError, data: getAccountData, refetch: getAccountRefetch} = useQuery(GET_ACCOUNT, {
        skip: target.type !== 'account' || !target.id,
        variables: {accountId: target.id},
    });

    const {error: getContactError, data: getContactData, refetch: getContactRefetch} = useQuery(GET_CONTACT, {
        skip: target.type !== 'contact' || !target.id,
        variables: {contactId: target.id},
    });

    const {error: getProjectError, data: getProjectData, refetch: getProjectRefetch} = useQuery(GET_PROJECT, {
        skip: target.type !== 'project' || !target.id,
        variables: {projectId: target.id},
    });

    useEffect(() => {
        if (getUserResourcesError) notify('getUserResourcesError', 'error', getUserResourcesError.message);
        if (getAccountError) notify('getAccountError', 'error', getAccountError.message);
        if (getContactError) notify('getContactError', 'error', getContactError.message);
        if (getProjectError) notify('getProjectError', 'error', getProjectError.message);
    }, [getUserResourcesError, getAccountError, getContactError, getProjectError]);

    useEffect(() => {
        if (getUserResourcesData) {
            setResources(getUserResourcesData.userResources);
        }
    }, [getUserResourcesData]);

    useEffect(() => {
        if (getAccountData && getAccountData.account) {
            const theAccount = {
                type: 'account',
                id: getAccountData.account.accountId,
                name: getAccountData.account.accountName
            };
            setTarget(theAccount);
        }
    }, [getAccountData]);

    useEffect(() => {
        if (getContactData && getContactData.contact) {
            const theContact = {
                type: 'contact',
                id: getContactData.contact.contactId,
                name: getContactData.contact.displayName
            };
            setTarget(theContact);
        }
    }, [getContactData]);

    useEffect(() => {
        if (getProjectData && getProjectData.project) {
            const theProject = {
                type: 'project',
                id: getProjectData.project.projectId,
                name: getProjectData.project.projectName
            };
            setTarget(theProject);
        }
    }, [getProjectData]);

    useEffect(() => {
        if (target.type === 'account') getAccountRefetch();
        if (target.type === 'contact') getContactRefetch();
        if (target.type === 'project') getProjectRefetch();
    }, [getAccountRefetch, getContactRefetch, getProjectRefetch, target]);

    useEffect(() => {
        const t = {
            type: props.parentType ? props.parentType : 'general',
            id: props.parentId ? props.parentId : 'general',
            name: target.name ? target.name : '',
        };
        setTarget(t);
    }, [props.parentId, props.parentType]);

    return (
        <>
            {target && target.type && resources && (
                <div>
                    <ChooseTargetDialog
                        open={chooseTargetDialogOpen}
                        title='Change ShareTarget'
                        parentType={target.type}
                        parentId={target.id}
                        handleYes={(newTarget) => {
                            setChooseTargetDialogOpen(false);
                            setTarget(newTarget);
                            props.onChange(newTarget);
                        }}
                        handleNo={() => {
                            setChooseTargetDialogOpen(false);
                        }}
                    />
                    <Grid container className={classes.gridContainer}>
                        <Grid item xs={5} className={classes.middleField}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    required
                                    id="parentType"
                                    name="parentType"
                                    label="ShareTarget"
                                    fullWidth
                                    size="small"
                                    disabled
                                    value={TARGET_TYPES[target.type]}
                                />
                            </FormControl>
                        </Grid>
                        {target.type !== 'general' && (
                            <Grid item xs={5} className={classes.middleField}>
                                <FormControl
                                    className={classes.formControl}
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                >
                                    <TextField
                                        id="parentName"
                                        name="parentName"
                                        label=" "
                                        fullWidth
                                        size="small"
                                        disabled
                                        value={target.name}
                                    />
                                </FormControl>
                            </Grid>
                        )}
                        <Grid item xs={2} className={classes.rightField} style={{textAlign: 'right'}}>
                            <IconButton
                                color="inherit"
                                id='change-target'
                                name='change-target'
                                aria-label='change-target'
                                onClick={() => {
                                    setChooseTargetDialogOpen(true);
                                }}
                            >
                                <BuildIcon/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </div>
            )}
        </>
    )
};

export default ShareTarget
